import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { Input } from 'semantic-ui-react';

const searchStyle = { height: 37 };

const ENTER_KEY_CODE = 13;
const BACKSPACE_KEY_CODE = 8;

export default class EventSearchInput extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: '',
    };
  }

  onChange = (e, { value }) => this.setState({ value })

  onKeyDown = event => {
    const { keyCode } = event;
    if (ENTER_KEY_CODE === keyCode && !_.isEmpty(this.state.value)) {
      this.props.onSearch(this.state.value);
    }
  }

  onKeyUp = event => {
    const { keyCode } = event;
    if (BACKSPACE_KEY_CODE === keyCode && _.isEmpty(this.state.value)) {
      this.props.onClearSearch();
    }
  }

  render() {
    const { term } = this.state;
    return (
      <Input
        placeholder="Search..."
        value={term}
        style={searchStyle}
        onChange={this.onChange}
        onKeyDown={this.onKeyDown}
        onKeyUp={this.onKeyUp}
      />
    );
  }
}

EventSearchInput.propTypes = {
  onSearch: PropTypes.func.isRequired,
  onClearSearch: PropTypes.func.isRequired,
};



/** WEBPACK FOOTER **
 ** ./src/containers/event-feed/other-elements/event-search-input.js
 **/